import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Auth0Provider } from '@auth0/auth0-react';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <Auth0Provider
      domain="dev-es2jzi3cnioccgue.us.auth0.com"
      clientId="Eh5BB4M6wlIsToWdcsM3LU4ML0QkLHoS"
      authorizationParams={{
        redirect_uri: `${window.location.origin}/callback`,
        audience: "https://api.arcattend.com"
      }}
      onRedirectCallback={(appState) => {
        console.log("Auth0 redirect callback - letting AuthCallback component handle routing:", {
          appState,
          url: window.location.href
        });
        // Don't redirect here - let the AuthCallback component handle it
      }}
    >
      <App />
    </Auth0Provider>
  </BrowserRouter>
);